import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { QueryParam } from 'src/app/services/api.services';

/** Query params as emitted by DataSet before date-only conversion. */
export type DateFilterQueryParam = {
	param: string;
	value: QueryParam['value'] | Date;
};

@Injectable({ providedIn: 'root' })
export class CalendarDateService {
	/**
	 * Formats a Date as a calendar day (yyyy-MM-dd) in the browser's local timezone.
	 * Use for date-only filter params so Material datepicker local midnight is not
	 * shifted by toISOString() / UTC conversion.
	 */
	toCalendarDate(date: Date): string {
		return formatDate(date, 'yyyy-MM-dd', 'en-US');
	}

	/**
	 * Maps QueryParam values that are Date instances to yyyy-MM-dd calendar dates.
	 * Non-Date values are left unchanged.
	 */
	mapDateFiltersToCalendarDate(filters: DateFilterQueryParam[]): QueryParam[] {
		return filters.map((filter) =>
			filter.value instanceof Date
				? {
						param: filter.param,
						value: this.toCalendarDate(filter.value),
					}
				: (filter as QueryParam)
		);
	}
}
